<template>
  <app-card title="個人資訊">
    <app-overlay-loading :loading="queryLoading" />
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field
                :value="profileInfo.username"
                prepend-icon="perm_identity"
                label="ID"
                disabled/>
            </v-flex>

            <v-flex xs12 md6>
              <v-text-field
                :value="email"
                prepend-icon="email"
                label="信箱"
                disabled/>
            </v-flex>

            <v-flex xs12 md6>
              <v-text-field
                v-model="nickname"
                prepend-icon="face"
                label="顯示名稱"
                color="black"
                disabled
                validate-on-blur />
            </v-flex>

            <v-flex xs12 md6>
              <v-select
                v-model="gender"
                :items="genderOptions"
                :rules="genderRules"
                prepend-icon="wc"
                label="性別"
                color="black"
                disabled
                no-data-text=''/>
            </v-flex>

            <v-flex xs12 md6>
              <v-text-field
                v-model="parentMobilePhone"
                :rules="parentMobilePhoneRules"
                prepend-icon="phone"
                label="行動電話(家長)"
                color="black"
                disabled
                validate-on-blur />
            </v-flex>

            <v-flex xs12 md6>
              <v-select
                v-model="grade"
                :items="gradeOptions"
                :rules="gradeRules"
                prepend-icon="grade"
                label="年級"
                color="black"
                no-data-text=''/>
            </v-flex>

            <v-flex x12>
              <school-select ref="schoolSelect" v-model="school" :schoolSystemName="schoolSystemName"/>
            </v-flex>
          </v-layout>

          <v-layout v-if="errMsg">
            <v-flex x12>
              <v-alert
                transition="slide-y-transition"
                :value="true"
                type="error">
                {{errMsg}}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :loading="loading"
        color="primary"
        @click="submit"
        flat>
        儲存
      </v-btn>
    </v-card-actions>
  </app-card>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';
import {
  signupNickname,
  signupGender,
  signupGrade,
  signupMobile4parent
} from '@/validate-rules';
import SchoolSelect from './SchoolSelect';

export default {
  components: {
    'school-select': SchoolSelect
  },

  data() {
    return {
      valid: false,
      queryLoading: false,
      loading: false,
      errMsg: null,

      nickname: '',
      nicknameRules: signupNickname.rules(),

      gender: null,
      genderRules: signupGender.rules(),

      grade: null,
      gradeRules: signupGrade.rules(),

      schoolSystemName: '',

      school: {},

      parentMobilePhone: '',
      parentMobilePhoneRules: signupMobile4parent.rules()
    };
  },

  computed: {
    ...mapState({
      userid: state => state.userid,
      email: state => state.profile.email
    }),

    ...mapGetters({
      profileInfo: 'profileInfo',
      genderOptions: 'genderOptions',
      gradeOptions: 'gradeOptions'
    })
  },

  watch: {
    async grade(v) {
      if (!v) {
        return;
      }
      this.schoolSystemName = await this.getSchoolSystemNameByGrade(v);
    }
  },

  mounted() {
    this.loadProfile();
  },

  methods: {
    ...mapActions('user', {
      updateStudentProfile: 'updateStudentProfile',
      getStudentProfile: 'getStudentProfile',
      getSchoolSystemNameByGrade: 'getSchoolSystemNameByGrade'
    }),

    async loadProfile() {
      this.queryLoading = true;
      try {
        let profile = await this.getStudentProfile();

        this.nickname = this.profileInfo.nickname;
        this.gender = this.profileInfo.gender;
        this.grade = this.profileInfo.grade;
        this.schoolSystem = this.profileInfo.schoolSystemId;
        this.schoolSystemName = this.profileInfo.schoolSystemName;
        this.parentMobilePhone = this.profileInfo.parentMobilePhone;
        // this.school = this.profileInfo.schoolId;
        this.school = {
          id: this.profileInfo.schoolId,
          text: profile.metadata.schoolname
        };

        this.queryLoading = false;
      } catch (e) {
        console.error('failed to qeury student profile:', e.message);
      }
    },

    async submit() {
      let params = {
        grade: this.grade
      };
      if (this.school && this.school.id) {
        params.schoolid = this.school.id;
      }

      this.errMsg = null;
      this.loading = true;
      try {
        await this.updateStudentProfile(params);
      } catch (e) {
        this.errMsg = '儲存失敗';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>
